import React, { useState } from 'react';
import faqIcon from '../assets/faq_icon.png';
import FAQModal from './FAQModal';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';

export default function FaqButton() {
  const [open, setOpen] = useState(false);
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [showTermsOfService, setShowTermsOfService] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(true)}
        style={{
          position: 'absolute',
          top: 372,
          right: 0,
          zIndex: 1200,
          border: 'none',
          background: 'transparent',
          cursor: 'pointer',
        }}
      >
        <img src={faqIcon} alt="FAQ" style={{ width: 70, height: 70 }} />
      </button>
      <FAQModal
        open={open}
        onClose={() => setOpen(false)}
        onPrivacyPolicy={() => setShowPrivacyPolicy(true)}
        onTermsOfService={() => setShowTermsOfService(true)}
      />
      {showPrivacyPolicy &&
        <PrivacyPolicy onClose={() => setShowPrivacyPolicy(false)} />}
      {showTermsOfService &&
        <TermsOfService onClose={() => setShowTermsOfService(false)} />}
    </>
  );
}
